<div class="patient-ids-container">
  <ng-container *ngIf="patientIDs?.length > 0; else noIds">

    <!-- Section 1: Current Facility Patient ID -->
    <div class="section-1"
         style="border-bottom: 1px solid #f0f0f0;
                padding-bottom: 15px;">

      <div class="current-facility-section">
        <!-- Show current facility patient ID if exists -->
        <app-patient-id-card *ngIf="currentFacilityPatientId; else missingId"
                             [patientId]="currentFacilityPatientId"
                             variant="current">
        </app-patient-id-card>

        <!-- Show missing message if no current facility ID -->
        <ng-template #missingId>
          <div class="missing-id-message">
            <mat-icon>
              warning
            </mat-icon>
            <span>
              Missing patient ID for
              <strong>
                {{currentFacility}}
              </strong>
            </span>
          </div>
        </ng-template>

        <!-- Arrow animation when a patient ID is selected -->
        <div *ngIf="selectedPatientId && currentFacilityPatientId"
             class="arrow-animation">
          <div class="arrow">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <!-- Show selected patient ID -->
        <app-patient-id-card *ngIf="selectedPatientId"
                             [patientId]="selectedPatientId"
                             [selected]="true">
        </app-patient-id-card>
      </div>
    </div>

    <!-- Section 2: Pick Target Hospital Patient ID -->
    <div *ngIf="otherPatientIDs.length > 0"
         class="section-2">
      <!-- Show all other patient IDs when expanded -->
      <ng-container *ngIf="showOtherPatientIds">
        <div class="other-patient-ids">
          <app-patient-id-card *ngFor="let id of otherPatientIDs; trackBy: trackByPatientId"
                               [patientId]="id"
                               [clickable]="true"
                               [showClickHint]="true"
                               (cardSelected)="selectPatientId($event)">
          </app-patient-id-card>
        </div>
      </ng-container>

      <!-- Show link to expand other patient IDs if more than one -->
      <div *ngIf="!showOtherPatientIds && otherPatientIDs.length > 1"
           class="show-other-ids-link">
        <a href="#"
           (click)="toggleOtherPatientIds(); $event.preventDefault()">
          <mat-icon>
            visibility
          </mat-icon>
          <span>
            {{ selectedPatientId ? 'Choose a different facility to share' : 'Choose a facility to share' }} ({{otherPatientIDs.length}})
          </span>
        </a>
      </div>

      <!-- Hide link when expanded and more than one -->
      <div *ngIf="showOtherPatientIds && otherPatientIDs.length > 1"
           class="show-other-ids-link">
        <a href="#"
           (click)="toggleOtherPatientIds(); $event.preventDefault()">
          <mat-icon>
            visibility_off
          </mat-icon>
          <span>
            Hide other facilities
          </span>
        </a>
      </div>
    </div>

  </ng-container>

  <ng-template #noIds>
    <div class="no-ids-message">
      <mat-icon>
        info
      </mat-icon>
      <span>
        No patient IDs available
      </span>
    </div>
  </ng-template>
</div>
